import { resourceReducer, getResources } from 'redux-resource';
import { reset, httpStatusCodes } from 'redux-resource-plugins';
import metaReducer from './metaReducer';

const simoDevices = resourceReducer('simoDevices', {
  plugins: [reset, metaReducer, httpStatusCodes],
});

export default simoDevices;

export const getAllSimoDevices = (state, page = 1) =>
  getResources(state, `fetchAllSimoDevice_${page}`);
export const getSearchSimoDevices = (state, page = 1) =>
  getResources(state, `searchSimoDevices_${page}`);
export const getUserSimoDevices = (state, userId, page = 1) =>
  getResources(state, `fetchUserSimoDevices_${userId}_${page}`);
export const getSimoDevice = (state, id) => state.resources[id];
